import { jsx as _jsx } from "react/jsx-runtime";
import { renderToStaticMarkup } from 'react-dom/server';
import { SVGBoxesTree } from './components/SVGBoxesTree';
export function render(tree, options) {
    const result = renderToStaticMarkup(_jsx(SVGBoxesTree, { tree: tree, ...options }));
    return result;
}
//# sourceMappingURL=render.js.map